export default {
    'widgets.notifications.fusion-swap-view.status.pending': 'Ausstehend',
    'widgets.notifications.fusion-swap-view.status.filled': 'Abgeschlossen',
    'widgets.notifications.fusion-swap-view.status.false-predicate': 'Gefüllt',
    'widgets.notifications.fusion-swap-view.status.not-enough-balance-or-allowance': 'Gefüllt',
    'widgets.notifications.fusion-swap-view.status.partially-filled': 'Gefüllt',
    'widgets.notifications.fusion-swap-view.status.wrong-permit': 'Gefüllt',
    'widgets.notifications.fusion-swap-view.status.invalid-signature': 'Gefüllt',
    'widgets.notifications.fusion-swap-view.status.expired': 'Abgelaufen',
    'widgets.notifications.fusion-swap-view.status.cancelled': 'Abgebrochen',
    'widgets.notifications.fusion-swap-view.control.cancel': 'Abbrechen',
};
//# sourceMappingURL=de.js.map